module.exports = "/images/ico-visa.svg?bc04b42d2d54a8b845155309addc86e1";